import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BackForwardFilterComponent } from '@k2/common/filters/components/back-forward-filter.component';
import { DateFilterComponent } from '@k2/common/filters/components/date-filter.component';
import { K2SelectFilterComponent } from '@k2/common/filters/components/k2-select-filter.component';
import { SelectFilterComponent } from '@k2/common/filters/components/select-filter.component';
import { TextFilterComponent } from '@k2/common/filters/components/text-filter.component';
import { K2SelectModule } from '@k2/common/k2-select/k2-select.module';
import { UIModule } from '@k2/common/ui/ui.module';
import { UserSearchFilterComponent } from "@k2/common/filters/components/user-search-filter.component";
import { MatSelectModule } from "@angular/material/select";
import { NgxMatSelectSearchModule } from "ngx-mat-select-search";
import { MultiSelectFilterComponent } from "@k2/common/filters/components/multi-select-filter.component";
import { LocationFilterComponent } from '@k2/common/filters/components/location-filter.component';
import { MatInputModule } from '@angular/material/input';
import { LocationsModule } from '@k2/common/locations/locations.module';

const components = [
  SelectFilterComponent,
  K2SelectFilterComponent,
  MultiSelectFilterComponent,
  TextFilterComponent,
  BackForwardFilterComponent,
  DateFilterComponent,
  UserSearchFilterComponent,
  LocationFilterComponent,
  ];

const exports = [
  SelectFilterComponent,
  K2SelectFilterComponent,
  MultiSelectFilterComponent,
  TextFilterComponent,
  BackForwardFilterComponent,
  DateFilterComponent,
  UserSearchFilterComponent,
  LocationFilterComponent,
  MatInputModule
];

@NgModule({
  imports: [
    CommonModule,
    UIModule,
    FormsModule,
    ReactiveFormsModule,
    K2SelectModule,
    MatSelectModule,
    NgxMatSelectSearchModule,
    MatInputModule,
    LocationsModule
  ],
  declarations: components,
  exports: exports
})
export class FiltersModule {
}
